import { IDocument } from '@root/modules/Warehouse/interface';
import { Button, Form, Input, Typography } from 'antd';
import saveAs from 'file-saver';
import moment from 'moment';
import { formatDateTime } from '@root/utils/helpers/formatDate';

const CmtToDown = ({
  handleOpenEdit,
  openDownImg,
  setOpenEdit,
  setOpenDownImg,
  statusWarehouse,
  listClone
}: any) => {
  const OpenEdit = () => {
    setOpenEdit(true);
    setOpenDownImg(false);
  };
  const { Text } = Typography;
  const arrToMap: any[] = [listClone];
  const downloadImage = () => {
    const list: any[] = listClone.documents;
    list.forEach((element) => {
      saveAs(element.url, element.fileName);
    });
  };
  return (
    <>
      <div style={{ display: 'flex', gap: '10px' }}>
        <div className="attachUp" style={{ marginBottom: '10px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <p style={{ marginBottom: '0px' }}>Warehouse’s attachments</p>
            <Button
              type="primary"
              onClick={downloadImage}
              style={{
                cursor: 'pointer',
                background: '#3c3d5f',
                border: 'none'
              }}
            >
              Download
            </Button>
          </div>
          <div
            className="scrollImg"
            style={{
              height: '85px',
              overflowY: 'scroll',
              overflowX: 'scroll',
              width: '320px'
            }}
          >
            {listClone?.documents?.map((item: IDocument, index: number) => (
              <p key={index}>{item.fileName}</p>
            ))}
          </div>
        </div>
        <div className="commentCard" style={{ marginBottom: '10px' }}>
          <div
            className="wrapTitle"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <p>{listClone?.owner}</p>
            <p style={{ color: '#A3A3A3' }}>
              {/* {moment(listClone?.updated_at)
                .utc()
                .format('YYYY-MM-DD hh:mm:ss A')} */}
              {formatDateTime(listClone?.updated_at)}
            </p>
          </div>

          <Text>{listClone?.comment}</Text>
          {'edit' ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end'
              }}
            >
              <Button
                onClick={OpenEdit}
                htmlType="submit"
                type="primary"
                style={{
                  background: '#F8F9FE',
                  border: '1px solid #d9d9d9',
                  color: 'black',
                  borderRadius: '9px'
                }}
                disabled={
                  statusWarehouse === 'WarehouseApproved' ||
                  statusWarehouse === 'SellerApproved'
                    ? true
                    : false
                }
              >
                Edit
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default CmtToDown;
